export class CourseParticipantForm {

    private $root:JQuery;
    private prototype:string;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.prototype = this.$root.data('prototype');
        if (undefined !== this.prototype) {
            this.bindUI();
        }
    }

    private bindUI() {
        this.$root.find('.js-participant__add')
            .off('click')
            .on({ click: this.addParticipant });
        this.$root.find('.js-participant__remove')
            .off('click')
            .on({ click: this.removeParticipant });
    }

    private addParticipant = () => {
        let pointer = parseInt(this.$root.data('count')) + 1;
        let $participant = $(this.prototype.toString().replace(/__name__/gi, pointer.toString()))
        this.$root.data('count', pointer);
        this.$root.append($participant);
        this.bindUI();
    }

    private removeParticipant = (ev:MouseEvent) => {
        $(ev.currentTarget).closest('.js-course-participants__item').remove()
    }
}